<!-- 产品-设备详情 -->
<template>
  <div class="md-layout">
    <!-- 卡片 设备详情表格 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 弹窗-查询表单 -->
          <div class="md-layout card-form" style="max-width: 600px;">
            <!-- 选择栏-导入状态 {0: 全部, 1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入}-->
            <div class="md-layout-item md-size-40 left-layout-item">
              <md-field>
                <label>{{$I18n("import_state")}}</label>
                <md-select v-model="modalSearchData.sycn_state" :placeholder="$I18n('pls_input_role_id')">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("is_succ")}}</md-option>
                  <md-option :value="2">{{$I18n("pending")}}</md-option>
                  <md-option :value="3">{{$I18n("is_fail")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <!-- 选择栏-导入状态 {0: 全部, 1:支付成功;2:支付失败;3:已撤销4:未支付}-->
            <div class="md-layout-item md-size-40 left-layout-item">
              <md-field>
                <label>{{$I18n("order_state")}}</label>
                <md-select v-model="modalSearchData.order_state" :placeholder="$I18n('pls_input_role_id')">
                  <md-option :value="0">{{$I18n("all")}}</md-option>
                  <md-option :value="1">{{$I18n("success")}}</md-option>
                  <md-option :value="2">{{$I18n("fail")}}</md-option>
                  <md-option :value="3">{{$I18n("has_cancel")}}</md-option>
                  <md-option :value="4">{{$I18n("undo")}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20 left-layout-item">
              <md-button class= "left-icon md-info" @click="modal_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 按钮-提交查询 -->
          <div class="md-layout-item right-layout-item">
            <!-- 生成激活码 -->
            <md-button class="left-icon md-info" @click="add_active_code">
              {{$I18n("add_active_coee")}}
            </md-button>
            <!-- 生成激活码 -->
            <md-button class="left-icon md-info" @click="go_use_active">
              {{$I18n("use_active_code")}}
            </md-button>
            <!-- 生成激活码 -->
            <md-button class="left-icon md-info" @click="act_code_order">
              {{$I18n("act_code_list")}}
            </md-button>
          </div>
          <!-- 弹窗-表格
            ID
            用户ID
            企业名称
            体系
            文件下载链接
            文件处理数据数量详情
            状态 {1: 已导入, 2: 有错误, 3: 文件错误, 4: 待导入}
            导入时间
            完成时间
           -->
          <md-table v-model="modalTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="'ID'">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('spec_name')">{{ item.spec_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('company')">{{ item.comp_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sure_limit')">{{ item.public_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('use_place')">{{ item.cn_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('price')+ '/' +$I18n('total_price')">{{ item.price }}/{{item.total_price}}</md-table-cell>
              <md-table-cell :md-label="$I18n('order_state')">{{ item.order_state_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('sync_state')">{{ item.import_state }}</md-table-cell>
              <!-- 显示样式 : 总数/成功条数(绿色)/失败条数(红色) -->
              <md-table-cell :md-label="`${$I18n('mng_num')}/${$I18n('succ_num')}/${$I18n('fail_num')}`">
                {{item.mng_num}}/
                <span :style='{color:"green"}'>{{item.suc_num}}</span>/
                <span :style='{color:"red"}'>{{item.fail_num}}</span>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('expire_time')">{{ item.expire_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button v-if="item.state != 2" @click="edit_item(item)" @click.stop class="md-just-icon md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button v-else @click.stop class="md-just-icon left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <a v-if="item.file_url" :href="item.file_url" target="_blank">
                  <md-button @click.stop class="md-just-icon md-info left-icon">
                    <md-icon>description</md-icon>
                  </md-button>
                </a>
                <md-button v-else @click.stop class="md-just-icon left-icon">
                  <md-icon>description</md-icon>
                </md-button>

              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
          <!-- 弹窗-翻页 -->
          <table-page :total="import_total" :pageSize="import_pageSize" v-model="import_currentPage"/>
        </md-card-content>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal_modify"
      :title = "modalModifyTitle"
      :right = "!openModalType.includes('delete')"
      @submit= "modal_submit"
    >
      <!-- 弹窗-主体 -->
      <template slot="body">
        <!-- 导入文件表格弹窗 -->
        <div>
          <!-- 弹窗-选择栏-选择公司ID -->
          <modal-form-item :label='$I18n("company")' :required="true">
            <md-field>
              <md-select v-model="modalModifyData.comp_id" :placeholder="$I18n('pls_select')">
                <md-option v-for="comp in compData" :key  ="comp.comp_id" :value="comp.comp_id">
                  {{comp.comp_name}}
                </md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 弹窗-选择栏-商品选择 -->
          <modal-form-item :label='$I18n("product")' :required="true" v-if="modalModifyType === 'add'">
            <md-field>
              <md-select v-model="modalModifyData.product" :placeholder="$I18n('pls_select')">
                <md-option v-for="spec in modalSpec" :key="spec.id" :value="spec.id">
                  {{spec.name}}
                </md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 弹窗-选择栏-是否限制 -->
          <modal-form-item :label='$I18n("sure_limit")' :required="true">
            <md-field>
              <md-select v-model="modalModifyData.public" :placeholder="$I18n('pls_select')">
                <md-option :value="1">{{$I18n("not_limit")}}</md-option>
                <md-option :value="2">{{$I18n("limit")}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 弹窗-选择栏-使用地区 -->
          <modal-form-item :label='$I18n("use_place")' :required="true" v-if="modalModifyType === 'add'">
            <md-field>
              <md-select v-model="modalModifyData.use_zone" :placeholder="$I18n('pls_select')">
                <md-option :value="1">{{$I18n("china_land")}}</md-option>
                <md-option :value="2">{{$I18n("other")}}</md-option>
              </md-select>
            </md-field>
          </modal-form-item>
          <!-- 弹窗-时间选择-有效时间 -->
          <modal-form-item :label='$I18n("expire_time")' v-if="modalModifyType === 'add'">
            <md-field>
              <el-date-picker v-model="modalModifyData.gmt_expire" :placeholder="$I18n('no_change_and_repalce')" class="md-date-form-item" align="left" type="date" value-format="yyyy-MM-dd HH:mm:ss" />
            </md-field>
          </modal-form-item>
          <!-- 弹窗-输入栏-激活码数量 -->
          <modal-form-item :label='$I18n("count")' :required="true" v-if="modalModifyType === 'add'">
            <md-field :class="{'md-error' : error.number}">
              <md-input v-model="modalModifyData.number"/>
              <md-icon v-if="error.number">clear</md-icon>
            </md-field>
          </modal-form-item>
        </div>
      </template>
      <template slot="footer-btn">
        <div :style="{'position':'absolute','left': '36px'}">
          <span :style="{'margin-right': '24px'}">
            {{$I18n("price")}} : {{comp_price.toFixed(2)}}
          </span>
          <span>
            {{$I18n("total_price")}} : {{parseFloat(comp_price * (isNaN(modalModifyData.number) ?0 :modalModifyData.number),2).toFixed(2)}}
          </span>
        </div>
      </template>
    </simple-modal>

    <!-- 弹窗-确认窗口 -->
    <simple-modal
      ref    = "modal"
      :title = "$I18n('confirm_purchase')"
      @submit= "modal_sure_submit"
      @close = "openModal = false"
    >
      <!-- 弹窗-主体 -->
      <template v-if = "openModal" slot="body">
        <p class="check_modal">
          <label>{{$I18n("company")    }}</label> 
          : {{compData.filter(item => {return item.comp_id == modalModifyData.comp_id })[0].comp_name }}
        </p>
        <p class="check_modal">
          <label>{{$I18n("product")    }}</label> 
          : {{modalSpec.filter(item => {return item.id == modalModifyData.product })[0].name }}
        </p>
        <p class="check_modal">
          <label>{{$I18n("use_place")  }}</label> 
          : {{modalModifyData.use_zone == 1 ?$I18n("china_land") :$I18n("other") }}
        </p>
        <p class="check_modal">
          <label>{{$I18n("count")      }}</label> 
          : {{parseInt(modalModifyData.number)}}
        </p>
        <p class="check_modal">
          <label>{{$I18n("price")      }}</label> 
          : {{comp_price.toFixed(2)}}
        </p>
        <p class="check_modal">
          <label>{{$I18n("total_price")}}</label> 
          : {{total_price}}
        </p>
      </template>
    </simple-modal>

    <simple-modal ref="actcode" :title="$I18n('act_code_list')" @close="open_code = false" :large="true" :right="true" :submitBtn="false">
      <template v-if = "open_code" slot="body">
        <activation-code/>
      </template>
    </simple-modal>
    </div>
</template>
<script>
import { timestampToString } from "@/common/tools.js";
import ActivationCode from "./ActivationCode.vue";
export default {
  props: ["userinfo_database"],
  components: {
    ActivationCode
  },
  data() {
    return {
      open_code: false,

      openModifyModal  : false,
      modalModifyTitle : "",
      modalModifyType  : "add",

      modalSearchData : { // 弹窗-表单-检索数据
        sycn_state : 0,
        order_state : 0,
      },
      searchForm : { // 表单-表单数据
        searchType : "cdk",
        searchValue: "",
        state      : 0,
        comp_id    : "",
      },
      searchData : { // 表格-检索数据
        order_id : "",
        cdk      : "",
        state    : 0,
        comp_id  : this.UserInfo.comp_id,
      },
      icon  : "computer", // ICON
      title : this.$I18n("act_code_order"), // 卡片标题
      compData : [], // 公司数据
      selectedSpec: {},
      // 弹窗相关
      openModal: false,  // 是否打开弹窗
      openModalType : "upload", // 弹窗类型
      modalTitle : "",  // 弹窗标题
      // 弹窗表单相关
      modalData : {
        state: "0",
      },
      modalSpec: [],
      modalModifyData : {
        comp_id  : this.UserInfo.comp_id,
        comp_path: this.UserInfo.comp_path,
        product  : "",
        // spec_id  : "",
        public   : 1,
        use_zone : 1,
        gmt_expire:"",
        number   : 0,
      },
      // 弹窗表单报错相关
      error: {
        file : false,
      },
      // 弹窗表格数据
      modalTableInitData : [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,
    };
  },
  mounted : function() {
    this.api_getComp()
      .then(() => {
        this.searchForm.comp_id = this.UserInfo.comp_id;
        this.import_currentPage = 1;
        this.api_getBatchActCode();
        this.api_getModalSpec();
      })
  },
  watch: {
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    'modalModifyData.comp_id':{
      handler(newValue){
        const item = this.compData.filter(item => {return item.comp_id == this.modalModifyData.comp_id })[0]
        if(item){
          this.modalModifyData.comp_path = item.path;
        }
        if(newValue){
          this.modalModifyData.product = "";
          this.api_getModalSpec();
        }
      },
      immediate: true,
      deep: true,
    },

    'modalModifyData.product':{
      handler(newValue){
        if(newValue){
          this.modalModifyData.spec_id = newValue;
          this.selectedSpec = this.modalSpec.filter(item => item.id == newValue)[0]
        }
      },
      immediate: true,
      deep: true,
    },
    import_currentPage(){
      this.api_getBatchActCode();
    }
  },
  computed: {
    total_price(){
      return parseFloat(
        this.comp_price * (isNaN(this.modalModifyData.number) ?0 :this.modalModifyData.number), 2
      ).toFixed(2)
    },
    comp_price(){
      const cost_json = this.selectedSpec.cost_price ?JSON.parse(this.selectedSpec.cost_price) :"";
      let price = cost_json[this.modalModifyData.use_zone == 1 ?"CNY" :"USD"];
      if(isNaN(price)){
        return 0
      } else {
        return parseFloat(price);
      }
    },
    modalTableForm(){ // 弹窗-API提交用弹窗表格检索参数
      return {
        sycn_state  : this.modalSearchData.sycn_state,
        order_state : this.modalSearchData.order_state,
      }
    },
    modalTableData () { // 弹窗-表格-表格数据(处理后)
      if (!this.modalTableInitData || this.modalTableInitData.length === 0){
        return [];
      } else {
        return [...this.modalTableInitData]
          .map(item => {
            // 公司
            let company  = this.$I18n("unknow");
            this.compData.forEach(function(com){
                if(com.comp_id == item.comp_id){
                  company = com.comp_short_name ?com.comp_short_name :com.comp_name;
                }
            })
            // 导入状态
            let import_state = this.$I18n("unknow");
            if(item.sycn_state== 1){
              import_state = this.$I18n("succ_num");
            }else if(item.sycn_state == 2 ){
              import_state = this.$I18n("pending");
            } else if( item.sycn_state == 3){
              import_state = this.$I18n("error");
            }

            let cn_name = this.$I18n("unknow");
            if(item.use_zone== 1){
              cn_name = this.$I18n("china_land");
            }else if(item.use_zone == 2 ){
              cn_name = this.$I18n("other");
            }

            let public_name = this.$I18n("unknow");
            if(item.public== 1){
              public_name = this.$I18n("not_limit");
            }else if(item.public == 2 ){
              public_name = this.$I18n("limit");
            }

            let order_state_name = this.$I18n("unknow");
            if(item.order_state == 1){
              order_state_name = this.$I18n("success");
            }else if(item.order_state == 2 ){
              order_state_name = this.$I18n("fail");
            } else if( item.order_state == 3){
              order_state_name = this.$I18n("has_cancel");
            } else if( item.order_state == 4){
              order_state_name = this.$I18n("undo");
            }

            // 3个参数(确保是数字)
            item.mng_num  = isNaN(item.mng_num) ?0 :item.mng_num;
            item.suc_num  = isNaN(item.suc_num) ?0 :item.suc_num;
            item.fail_num = isNaN(item.fail_num)?0 :item.fail_num;

            item.gmt_create = isNaN(item.gmt_create) ?0 :parseInt(item.gmt_create);
            item.gmt_expire = isNaN(item.gmt_expire) ?0 :parseInt(item.gmt_expire);
            item.gmt_update = isNaN(item.gmt_update) ?0 :parseInt(item.gmt_update);
            return {
              order_state_name,
              import_state,
              public_name,
              company,
              cn_name,
              create_time : item.gmt_create ?timestampToString(item.gmt_create * 1000) :"",
              expire_time : item.gmt_expire ?timestampToString(item.gmt_expire * 1000) :"",
              update_time : item.gmt_update ?timestampToString(item.gmt_update * 1000) :"",
              ...item,
            }
          })
      }
    },
  },
  methods: {
    act_code_order(){
      this.$refs.actcode.open();
      this.open_code = true;
    },
    go_use_active(){
      window.open(this.userinfo_database + "/live_cdk?lang=" + this.$router.history.current.query.lang)
    },
    modal_changeSearchData(){ // 弹窗-重新查询弹窗内表格数据
      this.import_currentPage = 1;
      this.api_getBatchActCode();
    },
    api_getModalSpec(){
      this.$api.getGood({
        comp_id: this.modalModifyData.comp_id,
        comp_path: this.modalModifyData.comp_path,
      }) // api: /iot/dev/file/query
      .then(this.$Then(res => {
        this.modalSpec = res.data;
      }))
      .catch(this.$Catch(this.$I18n("get_error"),() => {
        this.modalSpec = [];
      }))
    },
    api_getBatchActCode (){ // API-提交xls文件数据
      this.$api.getActCodeBatch({
        ...this.modalTableForm,
        page_size: this.import_pageSize,
        page_no  : this.import_currentPage,
      }) // api: /iot/dev/file/query
        .then(this.$Then(res => {
          this.modalTableInitData = res.data;
          this.import_total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableInitData = [];
          this.import_total = 0;
        }))
    },
    api_getComp (){ // API-获取公司信息
      //获取菜单
      return this.$api.getCompanyList({}) // api: /user/company/query
        .then(this.$Then(res => {
          this.compData = res.data;
        }))
        .catch(this.$Catch("", () => {
          this.compData = [];
        }))
    },
    add_active_code(){
      this.modalModifyType = "add";
      this.modalModifyTitle = this.$I18n("add_cdk");
      if (this.compData.length === 0){
        this.$errorMsg(this.$I18n("unknown_error"))
        return;
      }
      this.modalModifyData = {
        "comp_id": this.UserInfo.comp_id,
        "comp_path": this.UserInfo.comp_path,
        "public" : 1,
        "use_zone"     : 1,
        "product" : "",
        "gmt_expire": "",
        "number" : 0.
      };
      this.error = {
        number : false,
      }
      this.$refs.modal_modify.open();
    },
    edit_item(item){
      this.modalModifyType = "edit";
      this.modalModifyTitle = this.$I18n("edit_cdk");
      if (this.compData.length === 0){
        this.$errorMsg(this.$I18n("unknown_error"))
        return;
      }
      this.modalModifyData = {...item};
      this.error = {
        number : false,
      }
      this.$refs.modal_modify.open();
    },
    modal_submit () { // 弹窗-提交表单
      if(this.modalModifyType === "add"){
        if(!this.modalModifyData.product || isNaN(this.modalModifyData.number) || parseInt(this.modalModifyData.number) <= 0){
          this.$errorMsg(this.$I18n("pls_check_verify"));
          return
        }
        if(isNaN(this.comp_price)){
          this.$errorMsg(this.$I18n("not_set_price"));
          return
        }
        this.openModal = true;
        this.$refs.modal.open();
      } else {
        this.$api.editActCodeBatch({ // api: /mall/cdk/batch/set
            ...this.modalModifyData,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal.close();
            this.api_getBatchActCode();
          }))
          .catch(this.$Catch(this.$I18n("fail_num")))
      }
    },
    modal_sure_submit() {
      this.$api.addActCodeBatch({ // api: /mall/cdk/batch/add
          ...this.modalModifyData,
          gmt_expire: this.modalModifyData.gmt_expire ?new Date(this.modalModifyData.gmt_expire.replace("00:00:00","23:59:59")).getTime()/1000 :0,
      })
        .then(this.$Then(res => {
          return this.$api.setPaymentOrder({
            ...res.data,
            comp_price : this.total_price,
            user_id    : this.UserInfo.user_id,
            type       : 4,
            goods_type : 106,
          })
        }))
        .then(this.$Then(res => {
          if(res.code == 515){
            this.$errorMsg(this.$I18n("send_fail_515"));
            return
          }
          setTimeout(() => {
            this.$successMsg(this.$I18n("succ_num"));
            this.$refs.modal_modify.close();
            this.$refs.modal.close();
            this.api_getBatchActCode();
          } , 2000)
        },[515]))
        .catch(this.$Catch(this.$I18n("fail_num")))
    },
  },
}
</script>
<style lang="scss" scoped>
  p.check_modal {
    text-align: left;
    & label{
      width: 80px;
      display: inline-block;
    }
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
    text-align: left;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

</style>
